import(/* webpackMode: "eager" */ "/codebuild/output/src2017367258/src/src/app/global-error.tsx");
